import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import QRCode from 'qrcode'
import { ASSETS } from 'lib/api/const'

export const CONTAINER_ID = 'user-qr-info__qr-area'

const QrCode = ({ hasLogo, text, width, margin }) => {
  useEffect(() => {
    try {
      QRCode.toCanvas(
        text,
        { errorCorrectionLevel: 'M', width, margin },
        (err, canvas) => {
          if (err) {
            throw err
          }

          const container = document.getElementById(CONTAINER_ID)

          if (hasLogo) {
            // adding a logo at center
            const logoSize = { width: 36, height: 36 }
            const logoBackgroundPadding = 6
            const context = canvas.getContext('2d')
            const imageObj = new Image()
            imageObj.src = ASSETS.PML_LOGO
            imageObj.onload = () => {
              context.fillStyle = '#fff'
              context.fillRect(
                canvas.width / 2 - logoSize.width / 2 - logoBackgroundPadding,
                canvas.height / 2 - logoSize.height / 2 - logoBackgroundPadding,
                logoSize.width + logoBackgroundPadding * 2,
                logoSize.height + logoBackgroundPadding * 2,
              )

              // fit the logo within its box without distorting its aspect ratio
              const aspectRatio = imageObj.naturalWidth / imageObj.naturalHeight
              const drawSize =
                aspectRatio >= 1
                  ? {
                      width: logoSize.width,
                      height: logoSize.width / aspectRatio,
                    }
                  : {
                      width: logoSize.height * aspectRatio,
                      height: logoSize.height,
                    }

              context.drawImage(
                imageObj,
                canvas.width / 2 - drawSize.width / 2,
                canvas.height / 2 - drawSize.height / 2,
                drawSize.width,
                drawSize.height,
              )
            }
          }

          if (container?.firstElementChild) {
            container.removeChild(container.firstElementChild)
          }
          container.appendChild(canvas)
        },
      )
    } catch (err) {
      throw new Error(err)
    }
  }, [hasLogo, margin, text, width])

  return <div className={CONTAINER_ID} id={CONTAINER_ID} />
}

QrCode.propTypes = {
  text: PropTypes.string.isRequired,
  hasLogo: PropTypes.bool,
  margin: PropTypes.number,
  width: PropTypes.number,
}

QrCode.defaultProps = {
  hasLogo: false,
  margin: 4,
  width: 250,
}

export default QrCode
